import React from "react";
import UsersPage from "../../../features/admin/users/users-page";

export default function Users() {
  return <UsersPage />;
}
